import axios from "axios";

//const API_URL = `https://216.98.8.233:8049/api/Authenticate/`;
const API_URL = `https://paymeapi.ligglo.co.ke/api/Authenticate/`;
const register = (username, email, password, phoneNumber) => {
  return axios.post(API_URL + "register-admin", {
    username,
    email,
    password,
    phoneNumber,
  });
};

const registerClientUser = (username, email, password, phoneNumber) => {
  return axios.post(API_URL + "register", {
    username,
    email,
    password,
    phoneNumber,
  });
};

const login = (username, password) => {
  return axios
    .post(API_URL + "loginweb", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.user) {
        localStorage.setItem("jwt", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("jwt");
  return axios.post(API_URL + "logoutweb").then((response) => {
    return response.data;
  });
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("jwt"));
};
const changePassword = (oldPassword, newPassword) => {
  return axios.post(API_URL + "changepassword", {
    oldPassword,
    newPassword,
  });
};

const resetPassword = (userId, password) => {
  return axios.post(API_URL + "resetpassword", {
    userId,
    password,
  });
};

const updatePhoneNumber = (userId, phoneNumber) => {
  return axios.post(API_URL + "updatephone", {
    userId,
    phoneNumber,
  });
};
const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  changePassword,
  resetPassword,
  registerClientUser,
  updatePhoneNumber,
};

export default AuthService;
